// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".display_region.el-select-dropdown.el-popper{border:none}.display_region.el-select-dropdown.el-popper .el-select-dropdown__item.selected{color:#ff3973}", ""]);
// Exports
module.exports = exports;
